import type { FaireProductEntity } from "../../entity_types/product";

export const p_2h8j98yzce: FaireProductEntity = {
  token: "p_2h8j98yzce",
  type: "product",
  name: "Moldavite Pieces",
  brandToken: "b_ciwhgi8nfq",
  brandName: "The Crystal Tabby",
  imageUrl:
    "https://cdn.faire.com/fastly/809c235f940ec305e3b300e3815020c1d4058ab3231d39b2822890d46953f818.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3609d01eafbd9912ea37741000d2041cd649fecf07e395f032171861cce897c0.jpeg",
    "https://cdn.faire.com/fastly/a0b97d5cd263f274fab1a372617a2c5979b8b029fb5f1825580f4fddbff141ca.jpeg",
    "https://cdn.faire.com/fastly/a5f2ca18ad63a9b1d7c3e7ef2c1aaaa2d4c0427f6cd5b3ae180b42ce2512d615.jpeg",
  ],
  priceDollars: 26.33,
  description:
    "✨ Moldavite Pieces ✨\n\nThese small, rare moldavite pieces features the distinctive sculpted texture and deep olive-green tone that makes moldavite so sought after. Naturally formed from a meteorite impact, each piece has an organic shape with etched surfaces that highlight its authenticity and rarity.\n\nCompact but powerful, these are perfect for collectors, jewelry makers, or customers looking to own a genuine piece of this legendary stone.\n\nProduct Details\n• Natural moldavite (small size, .4-.7 inch)\n• Raw, unpolished tektite formation\n• Deep green to olive coloration\n• Natural etched and sculpted surface texture\n• Each piece is one of a kind in shape and size\n• Ideal for collectors, crystal displays, or wire-wrapping\n• Authentic natural material — variations are expected and embraced\n\nMoldavite is often associated with transformation and rapid personal growth, and its extraterrestrial origin adds a sense of intrigue that consistently captivates customers.\n\nA strong addition for shops offering moldavite, rare tektites, and high-interest wholesale specimens with serious collector appeal. ✨",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:30.882Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
